<template>
    <div class="wrap-dashboard">
        <div class="main-content">
          <div class="title-page">Inventory</div>
          <span>This tool empowers you to track and analyze your clients’ gold holdings.</span>
          <div>
            <span>Holdings Summary</span>
          </div>
          <div class="title-input-container-wrap">
          <div class="wrap-summary">
            <div class="summary-data">
              <div>Total Weight</div>
              <div>
                <span>{{ this.totalWeight }}</span>
                <span> gram</span>
              </div>
            </div>
            <div class="summary-data">
              <div>Quantity of Pieces</div>
              <div>
                <span>{{ this.totalPieces }}</span>
                <span> Pieces</span>
              </div>
            </div>
          </div>
          <div class="title-input-container">
          <div class="container-filter">
            <input
              type="text"
              placeholder="Search By Depositor"
              v-model="filterDepositor"
            />
          </div>
        </div>
        </div>
  
          <!-- <div class="nav-tab">
            <span
              class="tab"
              :class="{ activeTab: typeDeposit == 'inventory' }"
              @click="filterTypeDeposit('inventory')"
              >Inventory</span
            >
            <span
              class="tab"
              :class="{ activeTab: typeDeposit == 'metal' }"
              @click="filterTypeDeposit('metal')"
              >List Metal</span
            >
          </div> -->
          <div v-if="this.typeDeposit == 'inventory'" class="content">
            <table>
              <thead>
                <tr id="top">
                  <th scope="col" style="width: 70px">No</th>
                  <th scope="col">Depositor</th>
                  <th scope="col">Weight (gr)</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody v-if="isLoadingData">
                <tr>
                  <td colspan="7">
                    <b-spinner></b-spinner>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(inventory, i) in filteredTransactions" :key="i">
                  <td data-label="No">
                    {{ (currentPage - 1) * perPage + (i + 1) }}
                  </td>
                  <td data-label="Trade Match Id">{{ inventory.depositor }}</td>
                  <td data-label="weight">{{ inventory.weight }}</td>
                  <td data-label="no bp batam">{{ inventory.quantity }}</td>
                  <td data-label="detaol">
                    <router-link :to="'/history-inventory-detail-off/' + inventory.depositor">
                      <button type="button" class="btn btn-outline-info btn-sm">
                        Detail
                      </button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-pagination v-model="currentPage" :total-rows="lengthData" :per-page="perPage" @change="handlePageChange"
              aria-controls="new-table" first-number last-number v-show="lengthData > 10"></b-pagination>
          </div>
  
          <div v-else>
            <list-metal-off :depositDatas="getDataDeposit" :totalDeposit="getTotalData" :pageNumber="currentPage"
              :totalPerPage="perPage" :isLoadingData="isLoading"></list-metal-off>
            <div class="content" :style="{ marginTop: '10px' }">
              <b-pagination v-model="currentPage" :total-rows="getTotalData" :per-page="perPage"
                @change="handlePageChange" aria-controls="new-table" first-number last-number
                v-show="lengthData > 10"></b-pagination>
            </div>
          </div>
        </div>
      </div>
  </template>
  
  <script>
  import axios from "axios";
  // import ExportDeposit from "../components/ExportDeposit.vue";
  import jsPDF from "jspdf";
  import html2canvas from "html2canvas";
  import ListMetalOff from "../../deposit/ListMetalOff.vue";
  export default {
    components: { ListMetalOff },
    // components: { ExportDeposit },
    data() {
      return {
        dataTransaction: [],
        //typeDeposit: "onexchange",
        type: "text",
        pageOfItems: [],
        currentPage: 1,
        perPage: 10,
        lengthData: 1,
        trade_id: [],
        offset: 0,
        data: [],
        form: {
          startDate: "",
          endDate: "",
          depositor: "",
        },
        toggleDownload: false,
        isHideDeposite: false,
        isLoadingData: false,
  
        //list metal
        activity: "deposit",
        typeDeposit: "inventory",
        owner: "",
        serialNumber: "",
        hallmark: "",
        dateType: "",
        status: [],
        lengDataMetal: 0,
        totalWeight: 0,
        totalPieces: 0,
        filterDepositor: '',
      };
    },
    mounted() {
      this.getData(this.currentPage, "offexchange");
    },
  
    methods: {
      openMenu() {
        this.toggleDownload = !this.toggleDownload;
      },
      handlePageChange(value) {
        this.getData(value, this.typeDeposit);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      filterTypeDeposit(value) {
        this.typeDeposit = value;
        this.getData(this.currentPage, value);
      },
      getData(value) {
        if (this.typeDeposit == "inventory") {
          this.isLoadingData = true;
          let offset = (value - 1) * this.perPage;
          let url;
          let role = sessionStorage.getItem("role");
          if (role == 2 || role == 3) {
            url =
              "v2/clearing/admin/abx/get/list/summary_inventory?startDate&endDate&limit=" +
              this.perPage +
              "&offset=" +
              offset +
              "&type=" +
              "offexchange";
          } else {
            url =
              "/v2/clearing/admin/bappebti/get/list/summary_inventory?startDate&endDate&limit=" +
              this.perPage +
              "&offset=" +
              offset +
              "&type=" +
              "offexchange";
          }
          axios.get(url).then((res) => {
            this.isLoadingData = false;
            this.dataTransaction = res.data.data.body;
            this.lengthData = res.data.data.count;
            this.totalWeight = res.data.data.total_weight;
            this.totalPieces = res.data.data.total_pieces;
          });
        } else {
          this.$store
            .dispatch("getListMetal", {
              activity: this.activity,
              perPage: this.perPage,
              currentPage: this.currentPage,
              startDate: this.startDate,
              endDate: this.endDate,
              type: "offexchange",
              owner: this.owner,
              serialNumber: this.serialNumber,
              hallmark: this.hallmark,
              dateType: this.dateType,
              status: this.status,
              contract_id: this.contract_id,
            })
            .then((res) => {
              this.lengDataMetal = res.length;
            });
        }
      },
      downloadDeposit() {
        // let fileName = "deposit-confirmation.pdf";
        let dataId = document.getElementById("downloadMenu");
        let pdf = new jsPDF({
          orientation: "portrait",
          format: "a4",
        });
        html2canvas(dataId, { useCORS: true, scale: 1 }).then((canvas) => {
          var margin = 8;
          var imgWidth = 210 - 2 * margin;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var pageHeight = 295;
          var heightLeft = imgHeight;
          let img = canvas.toDataURL("image/png", 1);
  
          var position = 1;
          pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          pdf.save("deposit-confirmation");
        });
      },
    },
    computed: {
      rows() {
        return (this.currentPage - 1) * this.perPage;
      },
      getDataDeposit() {
        return this.$store.state.vaultModul.depositData;
      },
      getTotalData() {
        return this.$store.state.vaultModul.totalData;
      },
      isLoading() {
        return this.$store.state.vaultModul.isLoading;
      },
      getDataContract() {
        return this.$store.state.vaultModul.dataContract;
      },
      getDataClient() {
        return this.$store.state.vaultModul.dataClient;
      },
      filteredTransactions() {
      return this.dataTransaction.filter((inventory) => {
        return inventory.depositor.toLowerCase().includes(this.filterDepositor.toLowerCase());
      });
    }
    },
  };
  </script>
  
  <style scoped>
  /*.wrap-dashboard {
    min-height: 100vh;
    margin: 0;
    display: grid;
    grid-template-rows: auto 1fr auto;
  }*/
  
  .title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  
  select,
  input {
    border-radius: 3px;
    border: 1px solid #a5a5a5a5;
    padding: 3px;
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  input:last-child {
    margin-bottom: unset;
  }
  
  .wrap-download {
    position: relative;
  }
  
  .menu-download {
    position: absolute;
    margin-bottom: 1rem;
    background: #fff;
    width: 17rem;
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
    border-radius: 5px;
    padding: 1rem;
    font-size: 13px;
    right: 0;
    top: 42px;
  }
  
  .nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
  }
  
  .tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
  }
  
  .tab:hover,
  .activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
  }
  
  .summary-data {
    transition: 0.3s;
    padding: 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    border: solid 1px #dddddd;
  }
  
  
  .summary-data div:last-child {
    font-size: 1.75rem;
    margin-right: 0.5rem;
    font-weight: bold;
  }
  
  .summary-data:hover {
    /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2); */
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  }
  
  .wrap-summary {
    margin-top: 10px;
    display: flex;
    width: 100%;
    margin-bottom: 2rem;
    gap: 1rem;
  }

  input {
  padding: 8px;
  border: 1.5px solid #ccc;
  border-radius: 7px;
  box-sizing: border-box;
  margin-top: 5px;
  margin: 15px;
  width: 19.5em;
  height: 45px;
  padding: 10px;
}

  .title-input-container-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center; 
  margin-bottom: 20px;
}
  </style>
  